<template>
  <div class="wrapper-popup" :class="{'p-active': active}" @click.self="deactivePopup()">
    <div
      ref="dialog"
      class="popup"
      role="dialog"
      aria-modal="true"
      :aria-hidden="active ? 'false' : 'true'"
      tabindex="-1"
    >
      <button
        v-if="close"
        type="button"
        class="close-icon"
        aria-label="Cerrar ventana"
        @click="deactivePopup()"
      ></button>
      
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      close: {
        type: Boolean,
        default: () => {
          return true
        }
      },
      pactive: Boolean
    },
    data() {
      return {
        lastFocusedElement: null
      }
    },
    computed: {
      active() {
        return this.pactive
      }
    },
    watch: {
      pactive(value) {
        if (value) {
          this.activatePopup()
          return
        }
        this.cleanupPopup()
      }
    },
    mounted() {
      if (this.pactive) {
        this.activatePopup()
      }
    },
    beforeDestroy() {
      this.cleanupPopup(false)
    },
    methods: {
      activatePopup() {
        document.querySelector('body').classList.add('popup-active')
        this.lastFocusedElement = document.activeElement
        this.$nextTick(() => {
          if (this.$refs.dialog) {
            this.$refs.dialog.focus()
          }
        })
        document.addEventListener('keydown', this.handleKeydown)
      },
      cleanupPopup(restoreFocus = true) {
        document.querySelector('body').classList.remove('popup-active')
        document.removeEventListener('keydown', this.handleKeydown)
        if (
          restoreFocus &&
          this.lastFocusedElement &&
          typeof this.lastFocusedElement.focus === 'function' &&
          document.contains(this.lastFocusedElement)
        ) {
          this.lastFocusedElement.focus()
        }
        this.lastFocusedElement = null
      },
      handleKeydown(event) {
        if (!this.pactive || !this.$refs.dialog) return
        if (event.key === 'Escape') {
          event.preventDefault()
          this.deactivePopup()
          return
        }
        if (event.key !== 'Tab') return

        const focusableSelectors = [
          'a[href]',
          'button:not([disabled])',
          'textarea:not([disabled])',
          'input:not([disabled])',
          'select:not([disabled])',
          '[tabindex]:not([tabindex="-1"])'
        ]
        const focusableElements = Array.from(
          this.$refs.dialog.querySelectorAll(focusableSelectors.join(','))
        ).filter((element) => !element.hasAttribute('disabled') && element.offsetParent !== null)

        if (focusableElements.length === 0) {
          event.preventDefault()
          this.$refs.dialog.focus()
          return
        }

        const first = focusableElements[0]
        const last = focusableElements[focusableElements.length - 1]

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault()
          last.focus()
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault()
          first.focus()
        }
      },
      deactivePopup() {
        this.$emit('popup-update', false)
      }
    }
  }
</script>

<style lang="scss" scoped>

.wrapper-popup {
  & {
    display: none;
  }
  &.p-active {
    position: fixed;
    z-index: 999;
    background-color: rgba(30, 30, 30, 0.87);
    color: #fff;
    width: 100%;
    height: calc( 100vh - 76px);
    left: 0;
    top: 76px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 60px 0;
    display: grid;
    overflow: auto;
  }
  .popup {
    position: relative;
    display: flex;
    align-items: center;
    margin: 0px;
    text-align: left;
    
    h3{
      font-size: 1.75rem;
    }
    
    .close-icon {
      position: absolute;
      z-index: 99999;
      top: 10px;
      right: 10px;
      display: inline-block;
      margin: 0;
      padding: 0;
      border: 0;
      width: 44px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: transparent;
      color: #ddd;
      border-radius: 0;
      cursor: pointer;
      vertical-align: top;
      background: rgba(0, 0, 0, 0.2);
      border-radius: 50%;
      appearance: none;
    }
    .close-icon::after, .close-icon::before {
        content: "";
        display: inline-block;
        position: absolute;
        top: calc(50% - 1px);
        height: 1.55px;
        width: 22px;
        left: calc(50% - 11px);
        display: inline-block;
        background-color: currentColor;
    }
    .close-icon::before {
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
    }
    .close-icon:after {
        -webkit-transform: rotate(-45deg);
        transform: rotate(-45deg);
    }
  }
  
}
</style>
